import axios from "axios";
import { dbPromise } from "../main";

export class Ordens {
    static autentica (dados) {
        return axios.post("/auth", dados);
    }

    static clear () {
        dbPromise
            .then((db) => {
                db
                    .transaction("ordens", "readwrite")
                    .objectStore("ordens")
                    .clear();
            });
    }

    /**
     *
     * @param data
     * @return {Promise<any>}
     */
    static add (data) {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("ordens", "readwrite")
                        .objectStore("ordens")
                        .put(data);
                })
                .then(() => resolve());
        });
    }

    static async setLatLong (key, geocode) {
        let ordem = await Ordens.get(key);
        if (ordem) {
            ordem.geocode = { latitude: geocode.lat, longitude: geocode.lng };
            await Ordens.add(ordem);
        }
    }

    static async setProdutos (key, produtos) {
        let ordem = await Ordens.get(key);
        if (ordem) {
            ordem.produtos = produtos;
            await Ordens.add(ordem);
        }
    }

    static async setCaixa (key, caixa) {
        let ordem = await Ordens.get(key);
        if (ordem) {
            ordem.caixa = caixa;
            await Ordens.add(ordem);
        }
    }

    /**
     *
     * @param key
     * @return {Promise<any>}
     */
    static del (key) {
        return new Promise(resolve => {
            dbPromise
                .then((db) => {
                    return db
                        .transaction("ordens", "readwrite")
                        .objectStore("ordens")
                        .delete(key);
                })
                .then(() => resolve());
        });
    }

    /**
     *
     * @param id
     * @return {Promise<any>}
     */
    static get (id) {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.get("/os/get/" + id);
                resolve(res.data);
            } catch (e) {
                reject(e);
            }
        });
    }

    /**
     *
     * @return {Promise<any>}
     */
    static getAll () {
        return new Promise(async (resolve, reject) => {
            try {
                let res = await axios.get("/os/list");
                resolve(res.data);
            } catch (e) {
                reject(e);
            }
        });
    }
}
